/**
 * The one place the filter suffix grammar is explained. Filter tables point here
 * with chips instead of repeating "supports the '!' exclude suffix" per row.
 */
const ROWS = [
  { op: ["name", "=value"], mark: "", text: "Exact match." },
  { op: ["name", "=value"], mark: "!", text: "Exclude records that match." },
  { op: ["name", "=value"], mark: "~", text: "Contains match, case-insensitive. Text fields only." },
  { op: ["name", "=2020-01-01"], mark: ">", text: "On or after. Date fields only." },
  { op: ["name", "=2020-01-01"], mark: "<", text: "On or before. Date fields only." },
];

export function ApiGrammarCard() {
  return (
    <section className="apiGrammarCard" id="grammar" aria-labelledby="apiGrammarTitle">
      <span className="apiEyebrow">Filter grammar</span>
      <h2 className="apiSubhead" id="apiGrammarTitle">One grammar for every list filter</h2>
      <p className="apiSmall">
        Every filter on a list endpoint accepts the same suffixes. Chips beside each filter show which apply.
      </p>
      <div className="apiGrammarRows">
        {ROWS.map((row) => (
          <div className="apiGrammarRow" key={row.mark || "exact"}>
            <span className="apiGrammarOp">
              {row.op[0]}
              {row.mark && <span className="apiGrammarOpMark">{row.mark}</span>}
              {row.op[1]}
            </span>
            <span className="apiSmall">{row.text}</span>
          </div>
        ))}
      </div>
      <p className="apiSmall apiSmallMeta">
        Filters combine with <code className="apiInlineCode">&amp;</code> and all must match. Example:{" "}
        <code className="apiInlineCode">?observatory=ACE&amp;start_time&gt;=2010-01-01</code>
      </p>
    </section>
  );
}
